export default (function () {
  // Header mobile menu
  $(".header-btn").click(function () {
    $(this).parent(".header-nav").toggleClass("open-nav");
    $("body").toggleClass("open-nav");
  }); // Hero slider

  $(".hero-slider").slick({
    dots: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: false,
    pauseOnFocus: false
  }); // Block video

  $(".block-video").click(function () {
    var $this = $(this);
    $this.find(".block-video-overlay").hide();
    $this.find(".block-video-media")[0].src += "&autoplay=1";
    setTimeout(function () {
      $this.find(".block-video-media").show();
    }, 200);
  });
  $(".link-video").click(function () {
    event.preventDefault();
    var $this = $(this);
    $this.closest(".section-video").find(".block-video-overlay").hide();
    $this.closest(".section-video").find(".block-video-media")[0].src += "&autoplay=1";
    setTimeout(function () {
      $this.closest(".section-video").find(".block-video-media").show();
    }, 200);
  }); // Custom implemented video

  $(".block-video-custom").click(function () {
    var $this = $(this);
    $this.find(".block-video-overlay").hide();
    $this.find(".block-video-media")[0].play();
    console.log($this.find(".block-video-media")[0].style.display);
    setTimeout(function () {
      $this.find(".block-video-media").show();
    }, 200);
  });
  $(".link-video-custom").click(function (event) {
    event.preventDefault();
    var $this = $(this);
    $this.closest(".section-video-custom").find(".block-video-overlay").hide();
    $this.closest(".section-video-custom").find(".block-video-media")[0].play();
    setTimeout(function () {
      $this.closest(".section-video-custom").find(".block-video-media").show();
    }, 200);
  }); // Tabs

  $('.block-tabs-caption').on('click', 'li:not(.active)', function () {
    $(this).addClass('active').siblings().removeClass('active').closest('.block-tabs').find('.block-tabs-content').removeClass('active').eq($(this).index()).addClass('active');
  }); // Block Slideshow

  $(".block-slideshow").slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1
  }); // About page moving elements

  var aboutHeroInfo = document.querySelector('.hero-about-info');
  var aboutWrapper = document.querySelector('.about-wrapper');

  function mediaResizer() {
    if (window.matchMedia("(max-width: 767px)").matches) {
      if (aboutHeroInfo && aboutWrapper) {
        aboutWrapper.insertAdjacentElement('afterbegin', aboutHeroInfo);
        aboutHeroInfo.classList.add('elements-spacer');
      }
    } else {
      if (aboutHeroInfo) {
        var removeBackCont = document.querySelector('.about-hero .container .title-capitalize');
        removeBackCont.insertAdjacentElement('afterend', aboutHeroInfo);
      }
    }
  }

  if (aboutHeroInfo || aboutWrapper) {
    mediaResizer();
    window.addEventListener('resize', mediaResizer);
  } // Auto resize textarea


  $(".block-form textarea").on('input', function () {
    var scroll_height = $(".block-form textarea").get(0).scrollHeight;
    $(".block-form textarea").css('height', scroll_height + 'px');
  }); // Tabs Advantage page

  var tabsSmContainer = document.querySelector('.advantage-tabs-sm');
  var tabBtns = document.querySelectorAll('.tab');
  var tabLinks = document.querySelectorAll('.tab-link');
  var tabContentSections = document.querySelectorAll('.tab-content'); // Remove Element active classes

  var removeActiveTabs = function removeActiveTabs(elements, className) {
    elements.forEach(function (element) {
      element.classList.remove(className);
    });
  };

  if (tabsSmContainer) {
    // Add / remove active links styles
    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        //remove active class from tab btns
        removeActiveTabs(tabBtns, 'tab-active'); //add active class to current clicked btn

        btn.classList.add('tab-active'); //tab content

        tabsContent(btn);
      });
    }); // Prevent Default

    tabLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        return event.preventDefault();
      });
    });
  } // Add / remove active conteiners


  function tabsContent(el) {
    tabContentSections.forEach(function (tabSection) {
      var sectionId = tabSection.getAttribute('id');
      var linksPath = el.querySelector('.tab-link').dataset.path;

      if (linksPath === sectionId) {
        removeActiveTabs(tabContentSections, 'tab-content-active');
        tabSection.classList.add('tab-content-active');
      }
    });
  } ///// TINY SLIDER


  var slidersModal = document.querySelectorAll('.block-slideshow-modal');
  var popupSliders = [];

  if (slidersModal.length > 0) {
    slidersModal.forEach(function (slider) {
      var popupSlider = tns({
        container: slider,
        items: 1,
        slideBy: 'page',
        autoplay: false,
        autoplayButton: false,
        arrowKeys: false,
        mouseDrag: true,
        speed: 400,
        loop: false
      });
      popupSliders.push(popupSlider);
    });
  } // Modal


  var modalLink = document.querySelectorAll('.modal-link');
  var tnsOuter = document.querySelectorAll('.tns-outer');
  var modalSlider = document.querySelectorAll('.modal-slider');
  tnsOuter.forEach(function (tiny) {
    tiny.addEventListener('click', function (event) {
      event.stopPropagation();
    });
  });
  modalSlider.forEach(function (slider) {
    slider.addEventListener('click', function () {
      slider.classList.remove('active');
      document.body.classList.remove('hide-body-scroll');
    });
  });
  modalLink.forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      var modalSlider = link.closest('.modal-parent').querySelector('.modal-slider');
      var slider = link.closest('.modal-parent').querySelector('.block-slideshow-modal');
      var closeBtn = link.closest('.modal-parent').querySelector('.close-btn');
      closeBtn.classList.add('active');
      modalSlider.classList.add('active');
      document.body.classList.add('hide-body-scroll');
      popupSliders.forEach(function (sl) {
        sl.goTo('first');
      }); //closeBtn

      closeBtn.addEventListener('click', function () {
        modalSlider.classList.remove('active');
        closeBtn.classList.remove('active');
        document.body.classList.remove('hide-body-scroll');
      });
    });
  }); // blog post social share

  $('.share a').on('click', function (e) {
    e.preventDefault();
    var u = $(this).attr('data-url');
    var t = $(this).attr('data-title');

    if ($(this).hasClass('fb')) {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(u) + '&t=' + t, 'blank', 'width=626,height=300');
    }

    if ($(this).hasClass('tw')) {
      window.open('https://twitter.com/intent/tweet?tw_p=tweetbutton&text=' + encodeURIComponent(t) + '&url=' + u, 'blank', 'width=626,height=300');
    }

    if ($(this).hasClass('li')) {
      window.open('https://www.linkedin.com/shareArticle?mini=true&source=QCIntegratedSolutions&url=' + u + '&title=' + encodeURIComponent(t), 'blank', 'width=626,height=300');
    }
  }); // gdpr cookie notice

  if (getCookie('qc_accepted_cookies') == undefined) {
    $('.cookie-notice').fadeIn();
  }

  $('.cookie-notice .btn').on('click', function (e) {
    e.preventDefault();
    setCookie('qc_accepted_cookies', 'true', 60);
    $('.cookie-notice').fadeOut();
  });
});

function setCookie(name, value, days) {
  var expires = "";

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }

  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) == ' ') {
      c = c.substring(1, c.length);
    }

    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }

  return null;
}

function eraseCookie(name) {
  document.cookie = name + '=; Max-Age=-99999999;';
}